import {
  useGetBasicSearchCreditorTabListApiDataQuery,
  useDisableCrediotrActionMutation,
  useLazySearchCreditorTabListDataQuery,
} from "@/services/creditors/creditorsReducers";
import Table from "@/components/Table/table";
import TitleComplement from "@/features/creditor/creditorsTab/components/titleComplement";
import { useColumnDefs } from "@/features/creditor/creditorsTab/Constant/creditorHeaderConst";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { ActiveClaimModel, NoClaimModel } from "./modelBox";
import { useCustomCellRenderers } from "./Constant/creditorCustomCellConst";
import { BasicSearch } from "./basicSearch";
import "./style.scss";
import { useParams } from "react-router-dom";
import AdvanceSearch from "./AdvanceSearch";
import CustomPagination from "@/components/Pagination/CustomPagination";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import { useGetCreditorAdvanceSearchDataMutation } from "@/services/advanceSearch/advanceSearchReducer";
import { useCase } from "@/features/case/use-case";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import CreditorBulkImport from "./components/CreditorBulkImport";
import { useLazyDownloadTemplateDocumentQuery } from "@/services/manualDataSource/ManualDataSourceReducer";
import { commonFormateName } from "@/utility/common";
type BasicSearchPayloadType = {
  claimId: string;
  creditorId: string;
  creditorName: string;
  debtorName: string;
  country: string;
  province: string;
  postalCode: string;
  phoneNumber: string;
  claimUpdateDate: string;
  caseId: string;
};

export default function CreditorTabContent() {
  const { caseId } = useParams();
  const caseData = useCase();
  const { t } = useTranslation();
  const columnDefs: any = useColumnDefs(caseData);
  const [showModal, setShowModal] = useState(false);
  const [activeClaim, setActiveClaim] = useState(null);
  const [creditor, setCreditor] = useState<{
    creditorId: string;
    creditorName: string;
  }>();
  const dispatch = useDispatch();
  const retainState = useSelector(
    (e: any) => e.retainState.creditorListTabState
  );
  const [showBasicSearch, setShowBasicSearch] = useState(false);
  const [isBasicSearchActive, setIsBasicSearchActive] = useState(
    retainState.isBasicSearchActive || false
  );
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [clearSearch, setClearSearch] = useState(
    retainState.clearSearch || false
  );
  const [searchUrl, setSearchUrl] = useState<any>({
    caseId: caseId,
    ...retainState.searchUrl,
  });

  const permissions = useSelector((state: any) => state.permissions);
  const { Creditor, ImportJob } = permissions;

  const [successPopUp, setSuccessPopUp] = useState(false);
  const [formValues, setFormValues] = useState<any>(
    retainState.formValues || {
      claimId: "",
      creditorId: "",
      creditorName: "",
      debtorName: "",
      country: "",
      province: "",
      postalCode: "",
      phoneNumber: "",
      claimUpdateDate: undefined,
    }
  );
  let tableLoadingData = customTableLoadingData;
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  const [paginationObj, setPaginationObj] = useState<any>(() => {
    let value: any = {
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize || paginationPageSize,
      SearchText: retainState?.SearchText || "",
      // SortOrder: "desc",
      // SortColumn: "UpdatedOn",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  });

  function handlePaginationData(data: any, columnTypesData: any) {
    setPaginationObj((prev: any) => {
      return {
        ...prev,
        SortOrder: data.SortOrder ,
        SortColumn: data.SortColumn ,
      };
    });
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: {
          SortOrder: data.SortOrder ,
          SortColumn: data.SortColumn ,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  let resetSortStatus = (defaultSort: string) => {
    let json: any = { ...retainState?.sortedColumnTypes };
    for (const key in json) {
      json[key] = { sort: null };
    }
    json[defaultSort] = { sort: "asc" };

    return json;
  };

  const [errorMsg, setErrorMsg] = useState("");
  const [searchQuery, setSearchQuery] = useState(retainState?.SearchText || "");
  const [isSearchActive, setIsSearchActive] = useState(
    retainState.isSearchActive || false
  );
  const [basicSearchPayload, setBasicSearchPayload] = useState<
    BasicSearchPayloadType | undefined
  >(retainState.basicSearchPayload || undefined);
  const [advanceSearchPayload, setAdvanceSearchPayload] = useState(
    retainState.advanceSearchPayload || {}
  );
  const [isAdvanceSearchActive, setIsAdvanceSearchActive] = useState(
    retainState.isAdvanceSearchActive || false
  );
    const { caseShortName, abbreviation } = useSelector(
      (state: any) => state.case
    );
    const [templateDownloadError, setTemplateDownloadError] = useState<
      string | undefined
    >("");
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [downloadDocument, { isLoading: templetDowmloadLoading }] =
      useLazyDownloadTemplateDocumentQuery();
    const handleDownloadBulkImportTemplate = async () => {
      try {
        await downloadDocument({
          url: "Creditor/DownloadCreditorTemplate",
          caseId: caseId,
          fileName: caseShortName
            ? commonFormateName(
                caseShortName,
                "CreditorImportTemplate",
                abbreviation
              )
            : "",
        }).unwrap();
      } catch (error) {
        if (
          error &&
          typeof error === "object" &&
          "data" in error &&
          error?.data
        ) {
          const errObj = JSON.parse((error as any).data);
          return setTemplateDownloadError(errObj?.message || errObj?.title);
        } else setTemplateDownloadError("Something went wrong!!");
      }
    };
    const handleClose = () => {
      setShowBulkUploadModal(false);
      templateDownloadError && setTemplateDownloadError("");
    };
  const [
    triggerSearch,
    {
      isFetching: quickSearchDataFetching,
      data: searchData,
      error: searchError,
      status: searchDataStatus,
    },
  ] = useLazySearchCreditorTabListDataQuery();
  const [
    getCreditorAdvanceSearchData,
    {
      data: avdavancedData,
      isLoading: advancedSearchLoading,
      error: advancedDataError,
      status: avdavancedDataStatus,
    },
  ] = useGetCreditorAdvanceSearchDataMutation();
  const handleSearch = (searchValue: string) => {
    setSearchQuery(searchValue);
    if (searchValue.trim() === "") {
      setIsSearchActive(false);
      setClearSearch(false);
      setIsBasicSearchActive(false);
      setIsAdvanceSearchActive(false);
      setBasicSearchPayload(undefined);
      setAdvanceSearchPayload({});
      setPaginationObj({
        PageNumber: 1,
        PageSize: paginationPageSize,
        SearchText: "",
        SortOrder: "asc",
        SortColumn: "CreditorName",
      });
      setSearchUrl({
        caseId: caseId,
      });
      dispatch(
        setComponentState1({
          entityName: "creditorListTabState",
          entityState: {
            sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
            SortOrder: "asc",
            SortColumn: "CreditorName",
            PageNumber: 1,
            SearchText: "",
            PageSize: paginationPageSize,
            isSearchActive: false,
            isBasicSearchActive: false,
            clearSearch: false,
            basicSearchPayload: undefined,
            advanceSearchPayload: {},
            isAdvanceSearchActive: false,
            searchUrl: {
              caseId: caseId,
            },
          },
        })
      );
    } else {
      setPaginationObj({
        PageNumber: 1,
        PageSize: paginationPageSize,
        SearchText: searchValue,
        SortOrder: "asc",
        SortColumn: "CreditorName",
      });
      setClearSearch(false);
      setIsSearchActive(true);
      setIsBasicSearchActive(false);
      setIsAdvanceSearchActive(false);
      setBasicSearchPayload(undefined);
      setAdvanceSearchPayload({});
      dispatch(
        setComponentState1({
          entityName: "creditorListTabState",
          entityState: {
            sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
            SortOrder: "asc",
            SortColumn: "CreditorName",
            PageNumber: 1,
            SearchText: searchValue,
            PageSize: paginationPageSize,
            isAdvanceSearchActive: false,
            isSearchActive: true,
            isBasicSearchActive: false,
            clearSearch: false,
            basicSearchPayload: undefined,
            advanceSearchPayload: {},
          },
        })
      );
    }
  };
  const [disableCreditorAction, { isLoading: creditorDisable }] =
    useDisableCrediotrActionMutation();
  const disableCreditor = async () => {
    const response = await disableCreditorAction(creditor?.creditorId);
    //@ts-ignore
    if (response.hasOwnProperty("data") && response?.data === true) {
      setShowModal(false);
      setSuccessPopUp(true);
      refetch();
    } else {
      setShowModal(false);
      setSuccessPopUp(false);
    }
  };

  //Clear basic search
  function clearBasicSearch() {
    setSearchUrl({
      caseId: caseId,
    });
    setPaginationObj({
      PageNumber: 1,
      PageSize: paginationPageSize,
      SortOrder: "asc",
      SortColumn: "CreditorName",
    });
    setFormValues((prevValues: any) => ({
      ...prevValues,
      claimId: "",
      creditorId: "",
      creditorName: "",
      debtorName: "",
      country: "",
      province: "",
      postalCode: "",
      phoneNumber: "",
      claimUpdateDate: undefined,
    }));
    setAdvanceSearchPayload({});
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: {
          sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
          SortOrder: "asc",
          SortColumn: "CreditorName",
          PageNumber: 1,
          SearchText: "",

          PageSize: paginationPageSize,
          advanceSearchPayload: {},
          isAdvanceSearchActive: false,
          basicSearchPayload: undefined,
          isBasicSearchActive: false,
          searchUrl: {
            caseId: caseId,
          },
          formValues: {
            ...formValues,
            claimId: "",
            creditorId: "",
            creditorName: "",
            debtorName: "",
            country: "",
            province: "",
            postalCode: "",
            phoneNumber: "",
            claimUpdateDate: undefined,
          },
        },
      })
    );
    setIsBasicSearchActive(false);
    setIsAdvanceSearchActive(false);
    setBasicSearchPayload(undefined);
    setShowBasicSearch(false);
    setShowAdvanceSearch(false);
  }

  //Set up the form value
  const handleChange = (name: any, value: any) => {
    setFormValues({ ...formValues, [name]: value });
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: { formValues: { ...formValues, [name]: value } },
      })
    );
  };

  //Submit the form value in URL
  function handleSubmit() {
    setSearchQuery("");
    setIsSearchActive(false);
    setPaginationObj({
      PageNumber: 1,
      PageSize: paginationPageSize,
      SearchText: "",
      SortOrder: "asc",
      SortColumn: "CreditorName",
    });
    let formData = { ...formValues, caseId: caseId };

    if (formValues?.claimUpdateDate) {
      // Create a Date object
      const date = new Date(formValues?.claimUpdateDate);

      // Extract day, month, and year
      const day = ("0" + date.getDate()).slice(-2); // Ensure two digits
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Ensure two digits, month is 0-indexed
      const year = date.getFullYear();

      // Format in dd-mm-yyyy
      const updateDate = `${year}-${month}-${day}`;
      formData.claimUpdateDate = updateDate;
    }
    let basicSearchPayloadJson = { ...formData };
    if (formData.claimUpdateDate) {
      basicSearchPayloadJson = {
        ...formData,
        updateDate: formData.claimUpdateDate,
      };
    }
    setSearchUrl((prevValues: any) => ({
      ...basicSearchPayloadJson,
    }));
    setBasicSearchPayload({
      ...formData,
    });

    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: {
          sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
          SortOrder: "asc",
          SortColumn: "CreditorName",
          PageNumber: 1,
          SearchText: "",

          PageSize: paginationPageSize,
          basicSearchPayload: {
            ...formData,
          },
          isBasicSearchActive: true,
          clearSearch: true,
          isSearchActive: false,
          searchUrl: {
            ...basicSearchPayloadJson,
          },
        },
      })
    );

    setIsBasicSearchActive(true);
    setClearSearch(true);
  }
  function handleResetPaginationandQuickSearch() {
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: {
          sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
          SortOrder: "asc",
          SortColumn: "CreditorName",
          PageNumber: 1,
          SearchText: "",

          PageSize: paginationPageSize,
        },
      })
    );
    setSearchQuery("");
    setIsSearchActive(false);
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: { isSearchActive: false },
      })
    );
  }
  let basicSearchPayloadJson = { ...searchUrl, ...paginationObj };
  //Get data from API
  const { data, error, isFetching, isLoading, refetch, status } =
    useGetBasicSearchCreditorTabListApiDataQuery(
      { ...basicSearchPayloadJson },
      {
        skip: !searchUrl.caseId || isAdvanceSearchActive || isSearchActive,
        refetchOnMountOrArgChange: true,
      }
    );
  const handleQuickSearchClear = () => {
    setSearchQuery("");
    setIsSearchActive(false);
    setSearchUrl({
      caseId: caseId,
    });
    setPaginationObj({
      PageNumber: 1,
      PageSize: paginationPageSize,
      SearchText: "",
      SortOrder: "asc",
      SortColumn: "CreditorName",
    });
    setClearSearch(false);
    setIsBasicSearchActive(false);
    setIsAdvanceSearchActive(false);
    setBasicSearchPayload(undefined);
    setAdvanceSearchPayload({});
    dispatch(
      setComponentState1({
        entityName: "creditorListTabState",
        entityState: {
          isAdvanceSearchActive: false,
          isSearchActive: false,
          isBasicSearchActive: false,
          clearSearch: false,
          basicSearchPayload: undefined,
          advanceSearchPayload: {},
          sortedColumnTypes: { ...resetSortStatus("creditorNameType") },
          SortOrder: "asc",
          SortColumn: "CreditorName",
          PageNumber: 1,
          SearchText: "",
          PageSize: paginationPageSize,
          searchUrl: {
            caseId: caseId,
          },
        },
      })
    );
  };

  const handleEditSearch = () => {
    if (isAdvanceSearchActive) {
      setShowBasicSearch(false);
      setShowAdvanceSearch(true);
    } else if (isBasicSearchActive) {
      setShowBasicSearch(true);
      setShowAdvanceSearch(false);
    }
  };

  const caseRenderers = useCustomCellRenderers(
    setShowModal,
    setActiveClaim,
    setCreditor,
    Creditor
  );
  const headerData = {
    title: "pages.creditors.creditorTableTitle",
    description: "pages.creditors.creditorTableDescription",
  };
  useEffect(() => {
    if (isAdvanceSearchActive) {
      getCreditorAdvanceSearchData({
        ...advanceSearchPayload,
        ...paginationObj,
      })
        .then((response: any) => {})
        .catch((error) => null);
    } else if (isSearchActive) {
      triggerSearch({
        CaseId: caseId,
        ...paginationObj,
      }).unwrap();
    } else {
      refetch();
    }
  }, [
    paginationObj,
    caseId,
    getCreditorAdvanceSearchData,
    refetch,
    triggerSearch,
    advanceSearchPayload,
    isAdvanceSearchActive,
    isSearchActive,
  ]);
  if (isLoading) {
    return <MotifProgressLoader show variant="default" />;
  }

  let tableDataFetching =
    isFetching || quickSearchDataFetching || advancedSearchLoading;
  let tableData = tableDataFetching
    ? []
    : isAdvanceSearchActive
    ? avdavancedData?.results
    : isSearchActive
    ? searchData?.results
    : data?.results
    ? data?.results
    : [];
  let tableError = isAdvanceSearchActive
    ? advancedDataError
    : isSearchActive
    ? searchError
    : error;
  let nextDis = isAdvanceSearchActive
    ? avdavancedData?.hasMoreRecords
    : isSearchActive
    ? searchData?.hasMoreRecords
    : data?.hasMoreRecords;
  let apiRes = isAdvanceSearchActive
    ? avdavancedData
    : isSearchActive
    ? searchData
    : data;
  let apiStatus = isAdvanceSearchActive
    ? avdavancedDataStatus
    : isSearchActive
    ? searchDataStatus
    : status;
  return (
    <div
      className={
        (clearSearch ? " ccwp_creditor_header" : "") +
        (showBasicSearch || showAdvanceSearch ? " hide_claims_table" : "")
      }
    >
      {activeClaim === 0 ? (
        <NoClaimModel
          showModal={showModal}
          setShowModal={setShowModal}
          disableCreditor={disableCreditor}
          successPopUp={successPopUp}
          setSuccessPopUp={setSuccessPopUp}
          itemName={creditor?.creditorName}
          creditorDisable={creditorDisable}
        />
      ) : (
        <ActiveClaimModel
          showModal={showModal}
          setShowModal={setShowModal}
          activeClaim={activeClaim}
          setActiveClaim={setActiveClaim}
          itemName={creditor?.creditorName}
        />
      )}
      {errorMsg && (
        <NotificationGrid show={true} type="error" message={errorMsg} />
      )}
      <Table
        columnDefs={columnDefs}
        cellRenderers={tableData}
        columnTypes={{ ...retainState.sortedColumnTypes }}
        handlePaginationData={handlePaginationData}
        paginationObj={paginationObj}
        TitleComplement={() => (
          <TitleComplement
            caseId={caseId}
            showBasicSearch={showBasicSearch}
            setShowBasicSearch={setShowBasicSearch}
            clearBasicSearch={clearBasicSearch}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            onSearch={handleSearch}
            handleQuickSearchClear={handleQuickSearchClear}
            resetSortStatus={resetSortStatus}
            searchQuery={searchQuery}
            showAdvanceSearch={showAdvanceSearch}
            setShowAdvanceSearch={setShowAdvanceSearch}
            basicSearchPayload={basicSearchPayload}
            isBasicSearchActive={isBasicSearchActive}
            advanceSearchPayload={advanceSearchPayload}
            isAdvanceSearch={isAdvanceSearchActive}
            handleEditSearch={handleEditSearch}
            Creditor={Creditor}
            ImportJob={ImportJob}
            setErrorMessage={setErrorMsg}
            setShowBulkUploadModal={setShowBulkUploadModal}
          />
        )}
        overlayNoRowsTemplate={
          tableDataFetching
            ? t(tableLoadingData)
            : tableError
            ? t("global.globalNotifications.wentWrong")
            : t("global.globalNotifications.noRecords")
        }
        title={headerData.title}
        description={headerData.description}
        pagination={false}
        caseRenderers={caseRenderers}
      />
      {!(showBasicSearch || showAdvanceSearch) && (
        <CustomPagination
          apiData={apiRes}
          apiStatus={apiStatus}
          currentpage={paginationObj.PageNumber}
          pageSize={paginationObj.PageSize}
          disableNext={!nextDis}
          onChangePageSize={(page: number) => {
            setPaginationObj({
              ...paginationObj,
              PageSize: page,
              PageNumber: 1,
            });
            dispatch(
              setComponentState1({
                entityName: "creditorListTabState",
                entityState: {
                  PageSize: page,
                  PageNumber: 1,
                },
              })
            );
          }}
          onChangeNextPage={() => {
            setPaginationObj({
              ...paginationObj,
              PageNumber: paginationObj.PageNumber + 1,
            });
            dispatch(
              setComponentState1({
                entityName: "creditorListTabState",
                entityState: {
                  PageNumber: paginationObj.PageNumber + 1,
                },
              })
            );
          }}
          onChangePreviousPage={() => {
            setPaginationObj({
              ...paginationObj,
              PageNumber: paginationObj.PageNumber - 1,
            });
            dispatch(
              setComponentState1({
                entityName: "creditorListTabState",
                entityState: {
                  PageNumber: paginationObj.PageNumber - 1,
                },
              })
            );
          }}
          pageSizeSelector={paginationPageSizeSelector}
        />
      )}
      {showBasicSearch && (
        <BasicSearch
          handleChange={handleChange}
          setShowBasicSearch={setShowBasicSearch}
          handleSubmit={handleSubmit}
          basicSearchPayload={basicSearchPayload}
          showBasicSearch={showBasicSearch}
        />
      )}
      {showAdvanceSearch && (
        <AdvanceSearch
          setShowAdvanceSearch={setShowAdvanceSearch}
          setClearSearch={setClearSearch}
          handleResetPaginationandQuickSearch={
            handleResetPaginationandQuickSearch
          }
          advanceSearchPayload={advanceSearchPayload}
          setAdvanceSearchPayload={setAdvanceSearchPayload}
          setIsAdvanceSearchActive={setIsAdvanceSearchActive}
          setPaginationObj={setPaginationObj}
        />
      )}
       {showBulkUploadModal && (
        <CreditorBulkImport
          showModal={true}
          setShowModal={setShowBulkUploadModal}
          title={t("pages.creditors.creditorBulkImport.title")}
          description={t("pages.creditors.creditorBulkImport.description")}
          onDownload={handleDownloadBulkImportTemplate}
          uploadLabel={t("pages.creditors.creditorBulkImport.uploadLabel")}
          uploadDescription={t(
            "pages.creditors.creditorBulkImport.uploadDescriptionForXlsx"
          )}
          accept=".pdf,.jpg,.jpeg,.doc,.docx"
          maxFiles={1}
          onClose={handleClose}
          templateDownloadError={templateDownloadError}
          templetDowmloadLoading={templetDowmloadLoading}
          loadCreditorTable={handleQuickSearchClear}
        />
      )}
    </div>
  );
}
